<template>
    <div class="rightBox">
        <div class="right right1">
          <title-box :titleName="downtimeData.name" />
          <div class="content">
            <div class="frequency">
              <div class="title">{{downtimeData.content[0].title}}</div>
              <div class="lattice">
                <div class="latticeItem" v-for="(item,i) in mm()" :key="i">{{item}}</div>
              </div>
            </div>
            <div class="statistics">
              <div class="data">
                <div class="bigtitle">
                  <div>{{downtimeData.content[1].title}}</div>
                  <div>{{downtimeData.content[1].outageRate}}</div>
                </div>
                <div class="echartsbar">
                  <VueEcharts :option="downtimeData.content[1].option" autoresize></VueEcharts>
                </div>
                <img src="@/assets/img/组 19.png" alt="">
              </div>
              <div class="data">
                <div class="bigtitle">
                  <div>{{downtimeData.content[2].title}}</div>
                  <div>{{downtimeData.content[2].outageRate}}</div>
                </div>
                <div class="echartsbar">
                    <VueEcharts :option="downtimeData.content[2].option" autoresize></VueEcharts>
                </div>
                <img src="@/assets/img/组 19.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="right right2">
          <title-box titleName="设备数据" />
          <div class="content">
            <div class="top">
              <div class="topLeft">
                <div class="echartsImg">
                  <div class="rotate">135</div>
                </div>
                <div class="title">设备缺陷数(2021年)</div>
              </div>
              <div class="topRight">
                <div class="echartsImg">
                  <div class="rotate">135</div>
                </div>
                <div class="title">设备缺陷数(累计)</div>
              </div>
            </div>
            <div class="bottom">
              <div class="public public1">
                <div class="title">设备消缺率(2021年)</div>
                <div class="res">67%</div>
              </div>
              <div class="public public1">
                <div class="title">设备消缺率(累计)</div>
                <div class="res">67%</div>
              </div>
              <div class="public public2">
                平均负荷
              </div>
              <div class="public public2">
                额定容量
              </div>
            </div>
            
          </div>
        </div>
        <div class="right right3">
          <title-box :titleName="availabilityFactor.name" />
          <div class="content">
              <VueEcharts :option="availabilityFactor.option" autoresize></VueEcharts>
          </div>
        </div>
    </div>
</template>
<script>
import TitleBox from '@/components/title/index.vue'
import { mapState,mapActions } from 'pinia'
import useStore from '@/store/index.js' 
import * as echarts from "echarts";
export default {
  components:{
    TitleBox,
  },
  mounted(){
    this.res2()
    this.res1()
  },
  computed:{
    ...mapState(useStore,['downtimeData','availabilityFactor'])
  },
  methods:{
        ...mapActions(useStore,['res1','res2']),
    mm(){
      let str = this.downtimeData.content[0].res.toString()
      // 前面0的个数
      const count = 7 - str.length;
      for (let i = 0; i < count; i++) {
       str = '0'+ str
      }
      return str.split('')
    }
  }
};
</script>
<style scoped>
.rightBox{
  z-index: 10;
  width: 357px;
  height: 100%;
  display: flex;
  overflow: auto;
  padding-right:32px;
  flex-direction: column;
  box-sizing: border-box;
}
.right{
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.right1{
  flex:1
}
.right2{
  flex:1.1
}
.right3{
  flex:.9
}
.right .content{
  flex: 1;
  padding-top: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.right1 .statistics{
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.right1 .statistics .data{
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.right1 .statistics .data .echartsbar{
  flex: 1;
  overflow: hidden;
}
.right1 .statistics .data .bigtitle {
  display: flex;
  justify-content: space-between;
}
.right1 .frequency{
	height: 114px;
	background:url('@/assets/img/组\ 18.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  box-sizing: border-box;
}
.right1 .frequency .title{
  height: 20px;
  line-height: 20px;

}
.right1 .frequency .lattice{
  margin-top: 20px;
  width: 100%;
  height: 32px;
  display: flex;
}
.right1 .frequency .lattice .latticeItem{
  margin-right: 10px;
  width: 32px;
  height: 32px;
  background: url('@/assets/img/组\ 17\ 拷贝\ 6.png') no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-family: PangMenZhengDao;
}
.right2 .content .top,
.right2 .content .bottom{
  flex: 1;
}
.right2 .top,.right2 .content .bottom{
  display: flex;
  flex-wrap: wrap;
  align-content: space-around;
  justify-content: space-between;
}
.right2 .top .topLeft,
.right2 .top .topRight{
  width: 120px;
	height: 150px;
}
.right2 .top .topLeft .echartsImg,
.right2 .top .topRight .echartsImg
{
  width: 100%;
  height: 120px;
  overflow: hidden;
  
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 18px;
  
}
.right2 .top .topLeft .echartsImg{
  background:url('@/assets/img/组\ 161.png') no-repeat;
  background-size: 100%;
  animation:run 6s linear 0s infinite;
}
.right2 .top .topRight .echartsImg{
  background:url('@/assets/img/组\ 161\ 拷贝.png') no-repeat;
  background-size: 100%;
  animation:run 6s linear 0s infinite;
}
.right2 .top .topRight .title,
.right2 .top .topLeft .title{
  width: 100%;
  height: 30px;
  background:url('@/assets/img/组\ 162.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  
}
@keyframes run{     
  from{     
      -webkit-transform:rotate(0deg);     
  }     
  to{     
      -webkit-transform:rotate(360deg);     
  }     
}   
.rotate{
  animation:run1 6s linear 0s infinite;
}
@keyframes run1{     
  from{     
      -webkit-transform:rotate(0deg);     
  }     
  to{     
      -webkit-transform:rotate(-360deg);     
  }     
}

.public.public1{
	height: 50px;
  background:url('@/assets/img/组\ 165\ 拷贝\ 2.png') no-repeat;
  background-size: 100% ;
  flex-direction: column;
  font-size: 12px;
}
.public.public1 .res{
  color: #00fff9;
}
.public.public2{
  
	height: 40px;
  background:url('@/assets/img/组\ 168\ 拷贝.png') no-repeat;
  background-size: 100% 100%;
  font-size: 14px;
}
.public.public{
  width: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>